export default "__VITE_ASSET__C16$kn2w__"